function About(props) {
    return(
        <div class="main">
            <h1>About</h1>
            <p>Hi, I'm Bradley. I'm a software engineer with a background in life science 🧬, sustainability 🌎, and visual arts 🕺. I'm currently working on becoming an even stronger full stack developer 🖥 and finding Boston's best phở 🍜.</p>
            <p>As a software engineer, I leverage my past experience to make me a highly reliable engineer. My marine science background gives me an analytical approach and a curiosity to always learn more. My experience owning a dance studio gives me creativity, people skills, project management, and organization that make working in a team and meeting deadlines second nature!</p>
            <h2>Hobbies</h2>
            <div class="center">
            <div class="threecolumn">
            <h3>Dancing</h3>
            <img class ="hobbyPic" src="https://bradleymather.com/wp-content/uploads/2021/02/IMG_2834-3-scaled.jpg" alt="dancing"/>
            <p>I enjoy many dance styles, including:</p>
                <ul>
                    <li>Ballroom</li>
                    <li>Country</li>
                    <li>Swing</li>
                    <li>Line</li>
                </ul>
                </div>
            <div class="threecolumn">
            <h3>Fishkeeping</h3>
            <img class="hobbyPic" src="https://bradleymather.com/wp-content/uploads/2022/08/IMG_6963-scaled.jpg" alt="fishkeeping"/>
            <p>The types of fish I currently have are:</p>
                    <ul>
                        <li>Mollys</li>
                        <li>Platys</li>
                        <li>Fancy Goldfish</li>
                        <li>Angelfish</li>
                        <li>Guppies</li>
                        <li>Neon Tetras</li>
                        <li>Black Tetras</li>
                    </ul>
                    </div>
            <div class="threecolumn">
            <h3>Watching Reruns</h3>
            <img class="hobbyPic" src="https://www.indiewire.com/wp-content/uploads/2014/07/the-golden-girls.jpg" alt="reruns"/>
            <p>Some of my favorite classic shows are:</p>
                    <ul>
                        <li>The Golden Girls</li>
                        <li>I Love Lucy</li>
                        <li>Anything on Turner Classic Movies</li>
                    </ul>
                    </div>
            </div>
        </div>
    )
}
export default About